import { standardService } from 'Api/service';
import {
  saveAdminAuthToken,
  clearAdminAuthToken,
  getAdminAuthToken,
  ROOT_URL,
  adminAuthToken,
  saveError,
} from 'Api';
import { history } from 'Components/utils/router/history';
import { mapEntraParamsToAdminHeaders } from 'Containers/admin/OauthCallback/mapEntraParamsToAdminHeaders';
import { setErrors } from './dashboardActionCreators';
import {
  ADMIN_FIELD_CHANGED,
  LOGIN_ADMIN_SUCCESS,
  LOGIN_ADMIN_FAIL,
  CREATE_ADMIN_FAIL,
  LOGIN_ADMIN,
  SIGN_OUT_ADMIN_SUCCESS,
  SIGN_OUT_ADMIN_FAIL,
  SIGN_OUT_ADMIN,
  VALIDATE_ADMIN,
  VALIDATE_ADMIN_SUCCESS,
  VALIDATE_ADMIN_FAIL,
} from 'Constants/redux';

export const adminFieldChanged = ({ field, text }) => {
  return {
    type: ADMIN_FIELD_CHANGED,
    payload: { field, text },
  };
};

const loginAdminSuccess = (dispatch, admin) => {
  dispatch({
    type: LOGIN_ADMIN_SUCCESS,
    payload: admin,
  });
};
const validateAdminSuccess = (dispatch, user) => {
  dispatch({
    type: VALIDATE_ADMIN_SUCCESS,
    payload: user,
  });
};
const signOutAdminSuccess = (dispatch) => {
  dispatch({
    type: SIGN_OUT_ADMIN_SUCCESS,
  });
};

export const loginAdmin = ({ email, password }) => {
  return (dispatch, getState) => {
    dispatch({ type: LOGIN_ADMIN });

    standardService
      .post(`${ROOT_URL}/admin_auth/sign_in`, { email, password })
      .then((response) => {
        saveAdminAuthToken(response.headers);
        loginAdminSuccess(dispatch, response.data.data);

        if (history.location.state?.from) {
          history.push(history.location.state.from);
        } else {
          history.push('/tg-admin/businesses');
        }
      })
      .catch((error) => {
        saveError(error, getState());
        dispatch(setErrors(error.response.data.errors));
        dispatch({
          type: LOGIN_ADMIN_FAIL,
          payload: error.response.data.errors,
        });
      });
  };
};

// Friendly messages for the ?error=<reason> values the Rails Entra callback
// (Overrides::Admins::OmniauthCallbacksController#deny) can redirect back with.
const ENTRA_ERROR_MESSAGES = {
  unauthorized:
    'Your Microsoft account is not set up for TG-Admin. Ask an administrator to add you.',
  invalid_email:
    'We could not verify your Microsoft account. Please try again, or contact an administrator if this keeps happening.',
  invalid_request: 'We could not sign you in with Microsoft. Please try again.',
};

// Finalizes the Microsoft SSO login from the params devise_token_auth appended
// to the callback URL. `params` is an EntraCallbackParams object.
export const finalizeAdminOauth = (params) => {
  return (dispatch, getState) => {
    const headers = mapEntraParamsToAdminHeaders(params);

    if (params.error || !headers) {
      const message =
        ENTRA_ERROR_MESSAGES[params.error] ||
        'We could not sign you in with Microsoft. Please try again.';
      // Navigate FIRST: the reducer clears errors on LOCATION_CHANGE, so the
      // failure must be dispatched after the redirect to survive on the sign-in
      // screen.
      history.replace('/tg-admin');
      dispatch({ type: LOGIN_ADMIN_FAIL, payload: [message] });
      return;
    }

    saveAdminAuthToken(headers);

    // Hydrate state.admin_auth.user (needed for nav/permission gating) by
    // validating the freshly minted token, mirroring validateAdmin.
    standardService
      .get(`${ROOT_URL}/admin_auth/validate_token`, {
        uid: headers.uid,
        client: headers.client,
        'access-token': headers['access-token'],
      })
      .then((response) => {
        validateAdminSuccess(dispatch, response.data.data);
        saveAdminAuthToken(response.headers);
        const destination =
          history.location.state?.from || '/tg-admin/businesses';
        history.replace(destination);
      })
      .catch((error) => {
        saveError(error, getState());
        clearAdminAuthToken();
        history.replace('/tg-admin');
        dispatch({
          type: LOGIN_ADMIN_FAIL,
          payload: [
            'We could not verify your Microsoft session. Please try again.',
          ],
        });
      });
  };
};

export const validateAdmin = () => {
  return (dispatch, getState) => {
    dispatch({ type: VALIDATE_ADMIN });
    const authTokenHead = adminAuthToken();

    if (authTokenHead) {
      standardService
        .get(`${ROOT_URL}/admin_auth/validate_token`, {
          uid: authTokenHead['uid'],
          client: authTokenHead['client'],
          'access-token': authTokenHead['access-token'],
        })
        .then((response) => {
          validateAdminSuccess(dispatch, response.data.data);
          saveAdminAuthToken(response.headers);
        })
        .catch((error) => {
          saveError(error, getState());
          dispatch({ type: VALIDATE_ADMIN_FAIL });
          history.push({
            pathname: '/tg-admin',
            state: {
              from: history.location.pathname,
            },
          });
        });
    } else {
      dispatch({ type: VALIDATE_ADMIN_FAIL });
      history.push({
        pathname: '/tg-admin',
        state: {
          from: history.location.pathname,
        },
      });
    }
  };
};

export const createAdmin = ({ email, password, passwordConfirmation }) => {
  return (dispatch, getState) => {
    dispatch({ type: LOGIN_ADMIN });

    standardService
      .post(`${ROOT_URL}/admin_auth`, {
        email,
        password,
        password_confirmation: password,
      })
      .then((response) => {
        loginAdminSuccess(dispatch, response.data.data);
      })
      .catch((error) => {
        saveError(error, getState());
        dispatch(setErrors(error.response.data.errors));
        dispatch({
          type: CREATE_ADMIN_FAIL,
          payload: error.response.data.errors,
        });
      });
  };
};

export const signOutAdmin = () => {
  return (dispatch, getState) => {
    const headers = getAdminAuthToken();
    dispatch({ type: SIGN_OUT_ADMIN });

    standardService
      .delete(`${ROOT_URL}/admin_auth/sign_out`, {
        headers: headers,
      })
      .then((response) => {
        signOutAdminSuccess(dispatch, response.data.data);
        clearAdminAuthToken();
        history.push('/');
      })
      .catch((error) => {
        saveError(error, getState());
        dispatch({
          type: SIGN_OUT_ADMIN_FAIL,
          payload: error.response.data.errors,
        });
      });
  };
};
